'use strict';

exports.__esModule = true;
exports.default = exports.ProjectPage = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp, _class2, _temp2; // import {
//   Project as ProjectQuery,
//   createProjectProcessor,
//   updateProjectProcessor,
// } from "../query";


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _layout = require('../../layout');

var _layout2 = _interopRequireDefault(_layout);

var _ = require('../../404');

var _2 = _interopRequireDefault(_);

var _reactApollo = require('react-apollo');

var _context = require('@prisma-cms/context');

var _context2 = _interopRequireDefault(_context);

var _Project = require('../View/Project');

var _Project2 = _interopRequireDefault(_Project);

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // const UpdateProject = graphql(updateProjectProcessor)(ProjectView);
// const CreateProject = graphql(createProjectProcessor)(ProjectView);


var ProjectPage = exports.ProjectPage = (_temp = _class = function (_Page) {
  _inherits(ProjectPage, _Page);

  function ProjectPage() {
    _classCallCheck(this, ProjectPage);

    return _possibleConstructorReturn(this, _Page.apply(this, arguments));
  }

  ProjectPage.prototype.setPageMeta = function setPageMeta() {
    var meta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var project = this.props.data.object;

    if (!project) {
      return;
    }

    var name = project.name;
    return _Page.prototype.setPageMeta.call(this, _extends({
      title: "\u041F\u0440\u043E\u0435\u043A\u0442 " + name
    }, meta));
  };

  ProjectPage.prototype.componentWillMount = function componentWillMount() {
    var _context$query = this.context.query,
        createProjectProcessor = _context$query.createProjectProcessor,
        updateProjectProcessor = _context$query.updateProjectProcessor; // this.Renderer =

    this.CreateProject = (0, _reactApollo.graphql)((0, _graphqlTag2.default)(createProjectProcessor))(_Project2.default);
    this.UpdateProject = (0, _reactApollo.graphql)((0, _graphqlTag2.default)(updateProjectProcessor))(_Project2.default);
    _Page.prototype.componentWillMount && _Page.prototype.componentWillMount.call(this);
  };

  ProjectPage.prototype.render = function render() {
    var CreateProject = this.CreateProject,
        UpdateProject = this.UpdateProject;

    var _props = this.props,
        data = _props.data,
        other = _objectWithoutProperties(_props, ['data']);

    var project = data.object,
        loading = data.loading;

    if (!project) {
      if (loading) {
        return null;
      } else {
        return _react2.default.createElement(_2.default, null);
      }
    }

    var projectId = project.id;
    var Mutation = void 0;

    if (projectId) {
      Mutation = UpdateProject;
    } else {
      Mutation = CreateProject;
    }

    return _Page.prototype.render.call(this, _react2.default.createElement('div', null, _react2.default.createElement(Mutation, _extends({
      data: data
    }, other))));
  };

  return ProjectPage;
}(_layout2.default), _class.propTypes = _extends({}, _layout2.default.propTypes, {
  showDetails: _propTypes2.default.bool.isRequired
}), _class.defaultProps = _extends({}, _layout2.default.defaultProps, {
  showDetails: true
}), _temp); // export default (props) => {
//   return <ProjectQuery
//     View={ProjectPage}
//     {...props}
//   />
// };

var ProjectPageConnector = (_temp2 = _class2 = function (_Component) {
  _inherits(ProjectPageConnector, _Component);

  function ProjectPageConnector() {
    _classCallCheck(this, ProjectPageConnector);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  ProjectPageConnector.prototype.componentWillMount = function componentWillMount() {
    var project = this.context.query.project;
    this.Renderer = (0, _reactApollo.graphql)((0, _graphqlTag2.default)(project))(ProjectPage);
    _Component.prototype.componentWillMount && _Component.prototype.componentWillMount.call(this);
  };

  ProjectPageConnector.prototype.render = function render() {
    var Renderer = this.Renderer;
    return _react2.default.createElement(Renderer, this.props);
  };

  return ProjectPageConnector;
}(_react.Component), _class2.contextType = _context2.default, _temp2);
exports.default = ProjectPageConnector;